import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DepositProductIndexedDBService } from 'src/app/indexDB/depositProduct.service';
import { DepositProductService } from 'src/app/pages/settings/services/deposit-products.service';

@Component({
  selector: 'app-deposit-product-search-select',
  templateUrl: './deposit-product-search-select.component.html',
  styleUrls: ['./deposit-product-search-select.component.css']
})
export class DepositProductSearchSelectComponent implements OnInit, OnDestroy {

  @Input() showDefaultListValue: boolean = true;
  @Input() defaultSelected:any;
  @Input() control: FormControl | string;
  @Input() disabled: boolean = false;
  @Input() type: 'client' | 'server' = 'client';
  /** When given, replaces the cached deposit product list (client-side search). */
  @Input() options: { id: number, name: string }[] | null = null;
  @Output() emitSelectedVal: EventEmitter<any> = new EventEmitter();

  public depositLabel: string = $localize`:@@product:Product`;
  public depositProductData: { id: number, name: string }[] = [];
  public endpoint: string = '';
  public storedArrayString = localStorage.getItem('indexDBFetched');
  public storedArray = this.storedArrayString ? JSON.parse(this.storedArrayString) : [];
  private subscription: Subscription;
  
  constructor(
    private depositProductIDBService: DepositProductIndexedDBService,
    private depositProductService: DepositProductService
  ) { }

  ngOnInit(): void {
    if (this.options) {
      this.type = 'client';
      return;
    }
    this.getAllDepositProducts();
    this.endpoint = this.depositProductService.searchEndpoint;
    if (!this.storedArray.includes('depositProduct')) {
      this.type = 'server';
    }
  }

  emitSelected(value:{id:any, name:string}) {
    this.emitSelectedVal.emit(value);
  }

  getAllDepositProducts(){
    if (this.subscription) {
      // Unsubscribe from the previous subscription
      this.subscription.unsubscribe();
    }
    // The IndexedDB copy is filled once per browser and goes stale, so ask the API for the approved
    // list, refresh the cache with it, and only use the cached copy if the call fails.
    this.subscription = this.depositProductService.getAllRecordsUnpaged().subscribe({
      next: (res: any) => {
        const products = (res?.data ?? []).map((p: any) => ({ id: p.id, name: p.name }));
        this.depositProductData = products;
        this.depositProductIDBService.storeDataInIndexedDB(products);
      },
      error: () => {
        this.subscription = this.depositProductIDBService.getStoredData().subscribe({
          next: (depositProduct) => { this.depositProductData = depositProduct; },
          error: (error) => { console.error('Error retrieving deposit Products:', error); }
        });
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
